<template>
    <svg width="800"
            height="800"
            viewBox="0 0 800 800"
            version="1.1"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns="http://www.w3.org/2000/svg"
            class="category-menu-btn--image"
            role="img"
            :aria-label="alt">
        <image width="100%"
                height="100%"
                class="category-menu-btn--image-element"
                :xlink:href="url"
                :filter="imageFilter"
                :key="color"/>
    </svg>
</template>

<script>
    export default {
        props: {
            alt: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
            color: {
                type: String,
                required: true,
            },
        },
        computed: {
            imageFilter() {
                return `url(#svg-filter-source-flood-${ this.color })`;
            },
        },
    };
</script>
